import React from "react";
import "./HeroSlider.css";
import ImageSlider from "../../../theme/imageSlider/ImageSlider"; // Import your ImageSlider component
import { slides } from "../../../config/constants";

const HeroSlider = () => {
  return (
    <div className="container hero-slider-container">
      <ImageSlider slideImages={slides} /> {/* Pass the slides prop */}
    </div>
  );
};

export default HeroSlider;
